import React, { useMemo, useState, useEffect } from 'react';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import { usePeriodeKurbanUIContext } from '../../PeriodeKurbanUIContext';
import { initialFilter, categoryPeriode, tipePeriode } from '../../PeriodeKurbanUIHelpers';
import CurrencyInput from 'react-currency-input-field';
import { getThkPeriodAll } from '../../../../../_redux/periode-kurban/periodeKurbanCrud';

const prepareFilter = (queryParams, values) => {
	const { name, is_active, } = values;
	const newQueryParams = { ...queryParams };
	const filter = {};

	//add to Object filter
	filter.name = name ?? '';
	filter.is_active = is_active;
	newQueryParams.filter = filter;
	return newQueryParams;
};

export const PeriodeKurbanFilter = ({ listLoading }) => {
	// PeriodeKurban UI Context
	const periodeKurbanUIContext = usePeriodeKurbanUIContext();
	const periodeKurbanUIProps = useMemo(() => {
		return {
			setQueryParams: periodeKurbanUIContext.setQueryParams,
			queryParams: periodeKurbanUIContext.queryParams,
			filterType: periodeKurbanUIContext.filterType,
		};
	}, [periodeKurbanUIContext]);

	const applyFilter = (values) => {
		const newQueryParams = prepareFilter(periodeKurbanUIProps.queryParams, values);
		if (!isEqual(newQueryParams, periodeKurbanUIProps.queryParams)) {
			newQueryParams.pageNumber = 1;
			periodeKurbanUIProps.setQueryParams(newQueryParams);
		}
	};

	const [Periode, setPeriode] = useState([])

	useEffect(() => {

		const getPeriode = async () => {
			await getThkPeriodAll().then((response) => {
				setPeriode(response.data.data)
			}).catch((error) => {
				console.log(error);
			})
		}
		getPeriode()

	}, [])


	return (
		<Formik initialValues={initialFilter.filter} onSubmit={(values) => {
			applyFilter(values);
		}}
		>{({ values, handleSubmit, handleBlur, setFieldValue }) => (
			<form onSubmit={handleSubmit} className="form form-label-right">
				<div className="row">
					<div className="col-lg-4 mb-2">
						<input
							type="text"
							className="form-control"
							name="name"
							placeholder="Search"
							onBlur={handleBlur}
							value={values.name}
							onChange={(e) => {
								setFieldValue('name', e.target.value);
							}}
						/>
						<small className="form-text text-muted">
							<b>Cari</b> Berdasarkan Nama Periode Kurban
						</small>

					</div>
					<div className="col-lg-4 mb-2">

						<select
							name="is_active"
							placeholder="Text"
							label="Status Aktif"
							onBlur={handleBlur}
							className='form-control'
							onChange={(e) => {
								setFieldValue('is_active', e.target.value);
							}}
						>
							<option value="">--ALL--</option>
							<option value={true}>Aktif</option>
							<option value={false}>Non-Aktif</option>
						</select>
						<small className="form-text text-muted">
							<b>Cari</b> Berdasarkan Status Aktif
						</small>
					</div>

				</div>
				<button
					type="submit"
					onClick={() => handleSubmit()}
					className="btn btn-primary btn-elevate float-right mb-2"
				>
					Cari
				</button>
			</form>
		)}
		</Formik>

	);
};

